import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { CoreLanguageService } from '../../services/language.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CoreCOMService } from "../../services/com.service";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { MetaPixelService } from '../../services/tracking/meta-pixel.service';
import { CoreLogService } from "../../services/log.service";
import { CookieURL, CookieData, COOKIE_DATA } from "./cookieData"
import { TermService } from "../../components/term/term.service";
import { ImpressumTermViewModel } from "../../shared/models";
import { Router } from "@angular/router";
import { CookiePolicyService } from "./cookiePolicy.service";
import { ChefCampaignsService } from "../../services/ChefCampaignsService";

@Component({
  selector: "cookie-policy",
  templateUrl: "./cookiePolicy.component.html",
  styleUrls: ["./cookiePolicy.component.scss"],
  providers: [CookiePolicyService],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', border: '4px solid' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('2s'),
      ),
    ]),
  ]
})
export class CookiePolicyComponent implements OnInit {
  public tabeventStep = ["phCookieBanner_TabName_Privacy", "phCookieBanner_TabName_Cookie"];
  public currentLanguage: string;
  public expanded: boolean = true;
  public matGroupSelectedIndex: number = 0;
  public activeLink: string;
  public cookieConsentMetaChecked: boolean;

  public cookie_banner: boolean = true;
  public tableDataSource: MatTableDataSource<CookieURL>;
  public terms: ImpressumTermViewModel[] = [];
  public cookieDeclaration: string;
  displayedColumns: string[] = ['cookieName', 'service', "active"];
  expandedElement: CookieURL | null;

  constructor(
    private _coreCOMService: CoreCOMService,
    public bottomSheetRef: MatBottomSheetRef<CookiePolicyComponent>,
    private _coreLanguageService: CoreLanguageService,
    private _coreLogService: CoreLogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private MetaPixelService: MetaPixelService,
    private _termService: TermService,
    private _cookiePolicyService: CookiePolicyService,
    private _chefCampaingsService: ChefCampaignsService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public isCookieBanner: boolean
  ) { }

  private PushChanges(): void {
    const me = this;
    try {
      me._changeDetectorRef.detectChanges();
    } catch (e) {
      me._coreLogService.error("CookiePolicyComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.matGroupSelectedIndex = 0;
    me.activeLink = me.tabeventStep[0];
    me.currentLanguage = me._coreLanguageService.getCurrentLanguage();

    //checks if a checkmark for meta pixel should be set in the cookiepolicy table
    me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.cookieConsentMeta).then((cookieConsentMeta) => {
      cookieConsentMeta ? me.cookieConsentMetaChecked = true : me.cookieConsentMetaChecked = false;
    });

    me.tableDataSource = new MatTableDataSource([]);

    me.getTableData(me.currentLanguage).then(cookieData => {
      me.tableDataSource = new MatTableDataSource(cookieData);
      me.PushChanges();
    });

    me._termService.GetImpressumTermViewModel().then(terms => {
      me.terms = terms;
      me.PushChanges();
    });
    me._chefCampaingsService.load();
  }

  /** Shop uses Adyen */
  private async hasAdyen$(): Promise<boolean> {
    const me = this;
    return await me._cookiePolicyService.IsAdyenActive();
  }

  private async hasGooglePay$(): Promise<boolean> {
    const me = this;
    return await me._cookiePolicyService.IsGooglePayAvailable();
  }

  /** Shop uses Wallee) */
  private async hasWallee$(): Promise<boolean> {
    const me = this;
    return await me._cookiePolicyService.IsWalleeActive();
  }

  /** Shop uses Meta */
  public get hasMeta(): boolean {
    const me = this;
    return me._cookiePolicyService.IsMetaActive();
  }

  /** Shop uses Chef Campaigns */
  public get hasChefCampaigns(): boolean {
    const me = this;
    return me._chefCampaingsService.isActve();
  }

  private async getTableData(language: string): Promise<CookieURL[]> {
    const me = this;
    const CookieData: CookieURL[] = [];
    var LangCookieData: CookieData = COOKIE_DATA.en;
    if (language === "de") {
      LangCookieData = COOKIE_DATA.de;
    }

    me.cookieDeclaration = cookieDeclaration_de;
    try {
      if (await me.hasAdyen$()) {
        CookieData.push(...LangCookieData.ADYEN);
      }
    } catch (error) {
      me._coreLogService.error("CookiePolicyComponent.getTableData", "hasAdyen (catch)", error);
    }

    try {
      if (await me.hasWallee$()) {
        CookieData.push(...LangCookieData.WALLEE);
      }
    } catch (error) {
      me._coreLogService.error("CookiePolicyComponent.getTableData", "hasWallee (catch)", error);
    }

    try {
      if (await me.hasGooglePay$()) {
        CookieData.push(...LangCookieData.GOOGLE_PAY);
      }
    } catch (error) {
      me._coreLogService.error("CookiePolicyComponent.getTableData", "hasGooglePay (catch)", error);
    }

    try {
      if (me.hasMeta) {
        CookieData.push(...LangCookieData.META_PIXEL);
      }
    } catch (error) {
      me._coreLogService.error("CookiePolicyComponent.getTableData", "hasMeta (catch)", error);
    }

    try {
      if (me.hasChefCampaigns) {
        CookieData.push(...LangCookieData.CHEF_CAMPAIGNS);
      }
    } catch (error) {
      me._coreLogService.error("CookiePolicyComponent.getTableData", "hasMeta (catch)", error);
    }

    return CookieData;
  }

  //checks if meta pixel cookie is selected in the cookie policy table
  public handleCheckmarkChange(event) {
    const me = this;
    //! achtung, dass muss anders gelöst werden, damit es unabhängig von einem Literal funktioniert
    if (event.source.id === "_fbp") {
      if (event.checked) {
        me.cookieConsentMetaChecked = true;
      } else {
        me.cookieConsentMetaChecked = false;
      }
    }
  }

  //Accept all cookies
  public acceptAllCookies() {
    const me = this;
    me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsent, cookieVersion).then(() => {
      me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsentMeta, true)
      me.MetaPixelService.load();
      me.PushChanges();
      this.bottomSheetRef.dismiss(false);
    }).catch(e => {
      me._coreLogService.error("CookiePolicyComponent.acceptCookie", "valueStorage.set cookieConsent", e);
    });
  }

  public acceptOptionallCookies() {
    const me = this;
    me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsent, cookieVersion).then(() => {
      let needreload = false;
      me._coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.cookieConsentMeta, me.cookieConsentMetaChecked)
      if (me.cookieConsentMetaChecked) {
        me.MetaPixelService.load();
      } else {
        me.MetaPixelService.remove();
        needreload = true;
      }
      if (needreload) {
        location.reload();
      } else {
        me.bottomSheetRef.dismiss(false);
        me.PushChanges();
      }
    }).catch(e => {
      me._coreLogService.error("CookiePolicyComponent.acceptOptionallCookies", "valueStorage.set cookieConsent", e);
    });
  }

  public navigateToTerms(termID: number) {
    const me = this;
    me._router.navigate(["/termcondition", termID]);
    me.closeBottomSheet();
  }

  public closeBottomSheet() {
    this.bottomSheetRef.dismiss(true);
  }
}

/*
  Update Cookie Version after every change in ELEMENT_DATA_de/en
  CookieVersion will always be checked, so if changes happens all users have to accept the new/changed cookies
  (Major).(Minor)
*/
export const cookieVersion = 1.3;

//Content (text) of the Cookie policy
export const cookieDeclaration_de = "Im Rahmen der Services, insbesondere auf unseren Webseiten und Applikationen, werden automatisch allgemeine Informationen gesammelt, die Ihr Browser übermittelt. Diese Technologien sind erforderlich, um die Kernfunktionalität der Services zu aktivieren und können von Ihnen nicht deaktiviert werden. In unsere Datenschutzerklärung werden diese notwendigen funktionalen Verarbeitungen von personenbezogenen Daten als essenziell bezeichnet.";
export const cookieDeclaration_en = "Within the scope of the services, in particular on the websites and in the applications of Hypersoft, general information is automatically collected that is transmitted by your browser. These technologies are necessary to enable the core functionality of the Services and cannot be disabled by you. Hypersoft's Privacy Policy describes these necessary functional processing of personal data as essential.";
